import styled from "styled-components";
import {
  Sorriso as IconSorriso,
} from "../../../../components/TituloSorriso/styles";

export const Wrapper = styled.div`
  position: relative;
  background: ${(props) => props.backgroundColor};
  width: 100%;
  padding: 0 130px 32px 130px;

  @media(max-width: 1024px) {
    padding: 20px 0;
  }

  @media(max-width: 767px) {
    padding: 20px 0;
  }
`;

export const Title = styled.h2`
  font-weight: 500;
  font-family: 'Platform Web';
  line-height: 46.6px;
  font-size: 32px;
  max-width: max-content;
  color: #393939;
  padding: 32px 0 18px 0;

  @media(max-width: 900px) {
    font-size: 24px;
  }

  @media(max-width: 1024px) {
    padding: 20px 50px;
  }
`;

export const Sorriso = styled(IconSorriso)`
  margin-bottom: 0;
  filter: ${(props) => props.filter && `brightness(100)`};
`;
